/**
 * 深層拷貝
 */
export function deepClone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value))
}
